










































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import draggable from 'vuedraggable'
import Item from './item.vue'
import { Tooltip, Modal, message } from 'ant-design-vue'
import { getList, delCourse } from './data'
import { ListType, ItemType, ItemData } from '@/util/types'
import { shrinkSetData } from '@/util/dragThumb'
import Filters from '@/components/filter2'
import { detect } from 'detect-browser'
@Component({
  components: {
    draggable,
    Item,
    Filters,
    Modal
  }
})
export default class ListPage extends ViewBase {
  @Prop({ type: Number, default: ListType.cloudCourse }) type!: ListType

  @Prop({ type: Boolean, default: false }) enableDrag!: boolean

  @Prop({ type: Boolean, default: false }) hasPlaceholder!: boolean

  @Prop({ type: Boolean, default: false }) isCreatePage!: boolean

  @Prop({ type: Boolean, default: true }) isCloudSource!: boolean

  defaultQuery: any = {
    page: 1,
    pageSize: 20
  }

  // query: any = this.defaultQuery

  oldQuery: any = {}

  loading = false

  deleteModal = false

  deleteData: any = {}

  list: any[] = []

  total = 0
  // 是否现代不显示提示条的浏览器
  chrome = true

  get dragGroup() {
    return {
      name: 'playList',
      pull: 'clone',
      revertClone: true,
      put: (to: any, from: any, dragEl: HTMLElement, ev: DragEvent) => {
        if (to == from) {
          return true
        }
        return false
      }
    }
  }

  shrinkSetData = shrinkSetData

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  query: any = Object.assign(
    {},
    this.defaultQuery,
    this.isCreatePage ? {} : this.$store.state.searchQuery
  )

  get needRefreshMyCourse() {
    return this.$store.state.needRefreshMyCourse
  }

  created() {
    this.fetch()
    document.body.ondrop = e => {
        e.preventDefault()
        e.stopPropagation()
        e.returnValue = false
    }
      const { name } = detect() || { name: 'chrome' }
      const chrome = ['chrome', 'safari', 'opera'].includes(name) ? true : false
      this.chrome = chrome
  }
  mounted() {

    document.body.ondrop = e => {
        e.preventDefault()
        e.stopPropagation()
        // e.returnValue = false
    }
  }


  dragEnd(value: any) {
    if (this.$store.state.playItemIsRepeat) {
      this.$message.warning(this.i18n.vResItem.added)
    }
  }

  async fetch() {
    if (this.query.pageIndex == this.oldQuery.pageIndex) {
      this.query.pageIndex = 1
    }

    // 复制一份，预防被 fetch 改变
    const query = JSON.parse(JSON.stringify(this.query))
    this.oldQuery = { ...query }

    this.loading = true

    try {
      const { list, total } = await getList(this.type, query)
      this.list = list
      this.total = total
      // 删除课程成功后，剩下的课程不足2页时跳转到第一页
      if (total <= 20) {
        this.query.page = 1
      }
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.loading = false
    }
  }

  deleteTip(row: ItemData) {
    this.deleteData = row
    this.deleteModal = true
  }

  async delCourse() {
    const row: ItemData = this.deleteData
    this.deleteModal = false
    try {
      const res = await delCourse({ id: row.id })
      const index = this.list.indexOf(row)
      this.list.splice(index, 1)
      this.$notification.success({
        message: this.i18n.vCourse.delTip,
        description: this.i18n.vCourse.delClassSuccess
      })
      this.fetch()
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.loading = false
    }
  }

  setQuery(val: object) {
    this.query = Object.assign({}, this.defaultQuery, val)
    this.query.page = 1 // 筛选器变化重置页码
    // query存到store
    // this.$store.commit('setSearchQuery', this.query)
  }

  @Watch('query', { deep: true })
  watchQuery() {
    this.fetch()
  }

  @Watch('needRefreshMyCourse')
  watchNeedRefreshMyCourse(flag: boolean) {
    if (this.type !== ListType.myCourse) {
      return
    }
    if (!flag) {
      return
    }
    this.$store.commit('setNeedRefreshMyCourse', false)
    this.query.page = 1 // TODO: 筛选器的条件也清空
    this.fetch()
  }
}
